import React from 'react';
import { useSelector } from 'react-redux';
import SetupCard from './SetupCard';
import TextCenter from '../Typography/TextCenter';
import Header from '../Typography/Header';
import Subheader from '../Typography/Subheader';
import RealGrid from '../Layout/RealGrid';
import IntlMessages from 'util/IntlMessages';

const fields = [
  { id: 'name', title: "ui.setupRecs.setupRecsFields.name" },
  { id: 'product_type', title: "ui.setupRecs.setupRecsFields.productType" },
  { id: 'category', title: "ui.setupRecs.setupRecsFields.parentCategory" },
  { id: 'tags', title: "ui.setupRecs.setupRecsFields.tags" },
  { id: 'params', title: "ui.setupRecs.setupRecsFields.parameters" },
  { id: 'color', title: "ui.setupRecs.setupRecsFields.productImageColorAndShape" },
  { id: 'vendor', title: "ui.setupRecs.setupRecsFields.vendor" },
  { id: 'model', title: "ui.setupRecs.setupRecsFields.model" },
  { id: 'description', title: "ui.setupRecs.setupRecsFields.description" },
  { id: 'price', title: "ui.setupRecs.setupRecsFields.price" },
];

export default function SetupRecsFields({ onClick }) {
  const activeCards = useSelector((store) => store.onboarding.recs.fields);
  const cards = fields.map((field) => {
    const { id, title } = field;
    const active = activeCards.indexOf(id) > -1;
    return (
      <SetupCard active={active} key={id} title={title} onClick={() => onClick(id)} />
    );
  });

  return (
    <TextCenter>
      <Header variant="2"><IntlMessages id="ui.setupRecs.setupRecsFields.productAttributes" /></Header>
      <Subheader><IntlMessages id="ui.setupRecs.setupRecsFields.whatProductAttributesAreTheMostImportantToYourBusiness" /></Subheader>
      <RealGrid>{cards}</RealGrid>
    </TextCenter>
  );
}
